import { useRef, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
import useStores from '$src/hooks/useStores';
import breakpoints from '../constants/breakpoints';

export const BREAKPOINTS_SIZES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  DESKTOP_XL: 'desktopXl',
};

const MOBILE_DEVICES = [BREAKPOINTS_SIZES.MOBILE, BREAKPOINTS_SIZES.TABLET];
const getIsMobile = (breakpoint) => MOBILE_DEVICES.includes(breakpoint);

const getBreakpoint = () => {
  let breakpoint = null;

  if (typeof window !== 'undefined') {
    if (window.matchMedia(`(min-width: ${breakpoints.desktopXlMin}px)`).matches) {
      breakpoint = BREAKPOINTS_SIZES.DESKTOP_XL;
    } else if (window.matchMedia(`(min-width: ${breakpoints.desktopMin}px)`).matches) {
      breakpoint = BREAKPOINTS_SIZES.DESKTOP;
    } else if (window.matchMedia(`(min-width: ${breakpoints.tabletMin}px)`).matches) {
      breakpoint = BREAKPOINTS_SIZES.TABLET;
    } else {
      breakpoint = BREAKPOINTS_SIZES.MOBILE;
    }
  }

  return breakpoint;
};

// Returns a boolean if breakpoints correspond to a mobile device
const useBreakpoint = () => {
  const breakpoint = useRef();
  const { sessionStore } = useStores();

  const resizeEvent = useCallback(() => {
    breakpoint.current = getBreakpoint();
    sessionStore.setIsMobile(getIsMobile(breakpoint.current));
  }, [sessionStore]);

  resizeEvent();

  useEffect(() => {
    const resizeEventDebounce = debounce(resizeEvent, 200);
    window.addEventListener('resize', resizeEventDebounce);
    return () => {
      window.removeEventListener('resize', resizeEventDebounce);
    };
  }, [resizeEvent]);

  return breakpoint.current;
};

export default useBreakpoint;
